import { Injectable } from "@angular/core";

// rxjs
import { take } from 'rxjs/operators';
import { Observable } from 'rxjs';

// other services
import { HttpClient } from '@angular/common/http';

// models


// configuration
import { environment } from "../../environments/environment";

@Injectable({
    providedIn: 'root'
})
export class ChimeService {

    /**
     * constructor
     *
     * @param jwtHttp
     */
    constructor(
        private http: HttpClient
    ) { }

    /**
     * get all users
     *
     * @return {Observable<any>}
     */
    public getAll(): Observable<any> {
        return this.http.get(environment.api + '/chime/meeting/');
    }

    /**
     * get meeting by participant id
     *
     * @return {Observable<any>}
     */
    public getAllByParticipantId(partipantId: number): Observable<any> {
        return this.http.get(environment.api + '/chime/meeting/' + partipantId);
    }

    /**
     * get meeting by chat group id
     *
     * @return {Observable<any>}
     */
    public getAllByChatGroupId(chatGroupId: number): Observable<any> {
        return this.http.get(environment.api + '/chime/group-meeting/' + chatGroupId);
    }

    /**
     * check meeting by chat group id
     *
     * @return {Observable<any>}
     */
    public checkByChatGroupId(chatGroupId: number): Observable<any> {
        return this.http.get(environment.api + '/chime/check-group-meeting/' + chatGroupId);
    }
}
